import React, { PureComponent, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Row, Col, Collapse, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { number, object, array, func } from 'prop-types';
import { streams } from '../../services/ApiService';
import Card from '../Card/Card';
import FlowPostbackMethod from './FlowPostbackMethod';
import FlowPostbackUrl from './FlowPostbackUrl';
import FlowPostbackStatuses from './FlowPostbackStatuses';
import FlowPixels from './FlowPixels';
import AlertModal from '../../modals/AlertModal/AlertModal';
import { FMessage } from '../../hoc/IntlComponents';

class FlowPostback extends PureComponent {
  static propTypes = {
    pixels: array.isRequired,
    streamPixels: array.isRequired,
    statuses: array.isRequired,
    streamStatuses: array.isRequired,
    postback: object,
    streamId: number,
    onPostbackChange: func,
    onPixelChange: func,
    onStatusChange: func,
  };

  static defaultProps = {
    pixels: [],
    streamPixels: [],
    statuses: [],
    streamStatuses: [],
  };

  state = {
    loading: false,
    collapsed: true,
    modal: false,
    errorModal: false,
    postback: {
      method: 0,
      url: '',
    },
    response: '',
    error: '',
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { postback } = nextProps;

    if (postback) {
      this.setState(() => ({ postback }));
    }
  }

  togglePostback = () => {
    this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
  };

  toggleModal = () => {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  };

  toggleErrorModal = () => {
    this.setState((prevState) => ({ errorModal: !prevState.errorModal }));
  };

  handlePostbackChange = (data) => {
    this.setState(
      (prevState) => ({
        postback: {
          ...prevState.postback,
          ...data,
        },
      }),
      () => {
        this.props.onPostbackChange(this.state.postback);
      },
    );
  };

  checkPostback = () => {
    const { postback } = this.state;

    this.setState(() => ({ loading: true }));

    streams
      .checkPostback(postback)
      .then(({ items }) => {
        const data = items[0];

        this.setState(() => ({
          loading: false,
          response: data.response,
        }));

        this.toggleModal();
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error, code } = response.data.error;
          if (code !== 429) {
            this.setState(() => ({
              errorModal: true,
              error: error.message,
              loading: false,
            }));
          } else {
            this.setState(() => ({
              loading: false,
            }));
          }
        }
      });
  };

  render() {
    const { loading, postback, collapsed, modal, response, errorModal, error } = this.state;
    const { pixels, statuses, streamId, streamPixels, streamStatuses, className } = this.props;

    return (
      <Fragment>
        <Card loading={loading} className={className}>
          <h4>
            <FormattedMessage id="flow.form.postback.title" defaultMessage="Postback URL" />
          </h4>
          <Card.Body className="no-padding">
            {/* Postback method and URL */}
            <div>
              <FlowPostbackMethod
                method={postback.method}
                onPostbackMethodChange={this.handlePostbackChange}
              />

              <FlowPostbackUrl
                url={postback.url}
                onCheckPostback={this.checkPostback}
                onUrlChange={this.handlePostbackChange}
              />

              {/* Postback goals and statuses */}
              {pixels && statuses.length > 0 && (
                <div className='dropdown-toggle-wrapper'>
                  <Button
                    className="dropdown-toggle"
                    active={!collapsed}
                    color="light"
                    size="sm"
                    onClick={this.togglePostback}
                  >
                    <FormattedMessage id="flow.form.postback.settings" defaultMessage="Settings" />
                  </Button>

                  <Collapse isOpen={!collapsed}>
                    <div className="postback-extra-settings">
                      <FlowPixels
                        selected={streamPixels}
                        pixels={pixels}
                        onPixelChange={this.props.onPixelChange}
                      />

                      <FlowPostbackStatuses
                        onStatusChange={this.props.onStatusChange}
                        statuses={statuses}
                        selected={streamStatuses}
                      />
                    </div>
                  </Collapse>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>

        <ul className="postback-links list-inline no-margin">
          <li className="list-inline-item">
            <Link to="/faq/tools/flows/postback">
              <FormattedMessage id="flow.form.postback.help" defaultMessage="Help" />
            </Link>
          </li>

          {streamId && (
            <li className="list-inline-item">
              <Link to={`/postback/${streamId}`}>
                <FormattedMessage id="flow.form.postback.logs" defaultMessage="Logs" />
              </Link>
            </li>
          )}

          <li className="list-inline-item">
            <Link to="/tools/global-postback">
              <FMessage id="postback.global.title" />
            </Link>
          </li>
        </ul>

        <Modal size="lg" isOpen={modal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            <FormattedMessage id="flow.modal.postback-response" defaultMessage="Postback reponse" />
          </ModalHeader>
          <ModalBody>
            <pre>{response}</pre>
          </ModalBody>
        </Modal>

        <AlertModal open={errorModal} message={error} onClose={this.toggleErrorModal} />
      </Fragment>
    );
  }
}

export default FlowPostback;
